module.exports = __webpack_public_path__ + "static/cha-1A-b177a69fe8513041874df8f97d4c34c1.mp4";